import { derived } from "overmind"
import { AppState } from "src/state/_types"

export const state: AppState = {
    loading: true,
    online: false,
    settings: {
        theme: 'dark',
        locale: 'en'
    },
    auth: {
        auhthorized: derived((state: AppState['auth'])=>!!state.session_id),
        session_id: null,
        token: null,
        user_id: null,
        user_role: null,
        tenant_id: null,
        agency_id: null,
        user_type: null,
    },
    profile: null,
    user_name: derived((state: AppState)=>
        !!state ? (!!state.profile?.first_name?.length||!!state.profile?.last_name?.length) ? `${state?.profile?.first_name} ${state?.profile?.last_name}` : `User` : 'Guest'
    ),
    notifications: {
        permission: 'default',
        subscriptionId: null,
        initialized: false,
        promptDismissed: false,
    },
    ui: {
        view: 'list'
    }
}